<template>
  <div class="generic-layout">
    <Header/>
    <div class="main-wrapper container">
      <!-- Intro Section -->

      <!-- Main Section -->
      <div class="main-section">
        <!-- left col -->
        <div class="left-col">
          <div>
            <div class="step-badge">
              {{ stepText }}
            </div>
            <h2 class="title">Choose Your Account Type</h2>
            <p class="subtitle">Take a quick tour of our platform
              <VideoHoverPlayer title="Tour of Platform"
                                videoUrl="https://player.vimeo.com/video/1029251829"/>
            </p>

          </div>

          <div class="account-type" role="radiogroup" aria-label="Account Type">
            <input id="account-individual" type="radio" name="individual" value="individual" v-model="accountType"/>
            <label for="account-individual" class="account-type-card">
              <div class="" aria-hidden>
                <img src="@/assets/icons/profile.svg" alt=""/>
              </div>
              <div class="card-body">
                <h3>
                  Individual
                  <VideoHoverPlayer title="Employee Dashboard Tutorial Demo" videoUrl="https://player.vimeo.com/video/1102228245"/>
                </h3>
                <p>New Single User</p>
              </div>
              <div class="select-dot" aria-hidden></div>
            </label>

            <input id="account-company" type="radio" name="company" value="company" v-model="accountType"/>
            <label for="account-company" class="account-type-card">
              <div class="" aria-hidden>
                <img src="@/assets/icons/people.svg" alt=""/>
              </div>
              <div class="card-body">
                <h3>
                  Company
                  <VideoHoverPlayer title="Manager Dashboard Tutorial Demo" videoUrl="https://player.vimeo.com/video/1107417444"/>
                </h3>
                <p>New Company signup</p>
              </div>
              <div class="select-dot" aria-hidden></div>
            </label>
          </div>

          <ChoosePlatform v-if="isAccountType('company')" v-model="choosePlatform"/>
          <!-- Individual Course Selection -->
          <SelectCourses v-if="isAccountType('individual')" @courses-selected="onCoursesSelected" :courses="courses"
                         :accountType="accountType" :tempSelectedCourses="selectedCourses"
                         :tempSelectedSpecialCourses="selectedSpecialCourses" :loading="loadingCourses"/>
          <UserBillingInfo v-if="isAccountType('individual') && showBillingInfo"
                           @form-submitted="onBillingFormSubmitted" @billing-update="scheduleSaveLead" ref="userForm"/>
          <!-- Company Courses Selection -->
          <PlanSelector v-if="isAccountType('company') && isChoosePlatform('chooseLMS')" :plans="plans"
                        @plan-change="onPlanChange" @open-enterprise-modal="openEnterpriseModal"/>

          <EnterprisePlanModal
            :visible="isEnterpriseVisible"
            @close="isEnterpriseVisible = false"
          />
          <AddLocations v-if="isChoosePlatform('chooseOtherPlatform')" @locations-added="onLocationsAdded"
                        :users="users" :locations="locations"/>
          <SelectCourses v-if="isChoosePlatform('chooseOtherPlatform') && locationsAdded"
                         :choosePlatform="choosePlatform" :courses="courses" :accountType="accountType"
                         @courses-selected="onCoursesSelected" :tempSelectedCourses="selectedCourses"
                         :tempSelectedSpecialCourses="selectedSpecialCourses" :loading="loadingCourses"/>
          <IncludedCourses v-if="isAccountType('company') && selectedPlan && selectedPlan.plan" :plan="selectedPlan"
                           @courses-selected="onCoursesSelected" :courses="courses" :users="users"
                           :tempSelectedCourses="selectedCourses" :tempSelectedSpecialCourses="selectedSpecialCourses"/>
          <AddOns v-if="isAccountType('company') && selectedPlan && selectedPlan.plan"
                  :addons="addons" :selectedSpecialCourses="selectedSpecialCourses" :users="users"
                  @add-ons-selected="handleAddOnsSelected" @update-special-courses="handleAddonsCourses"/>
          <CompanyBillingInfo v-if="
            (isAccountType('company') && selectedPlan && selectedPlan.plan) ||
            (isChoosePlatform('chooseOtherPlatform') &&
              locationsAdded && showBillingInfo)" :choosePlatform="choosePlatform" :totals="totals"
                              :isChoosePlatform="isChoosePlatform" @form-submitted="onBillingFormSubmitted"
                              @billing-update="onCompanyBillingUpdate" ref="companyForm" @change-billing-cycle="billingCycleUpdate" />
        </div>

        <!-- right col (reserved for form/preview) -->
        <div class="right-col">
             <div class="intro-section">
        <!-- left col -->
        <!-- <div class="start-journey">
          <h2>Start Your Journey With Us</h2>
          <div class="info">

          </div>
        </div> -->
        <!-- right col -->
        <div class="trusted">
          <h4>Trusted by 1000+ companies</h4>
          <div class="sponsor-logos-container">
            <div class="sponsor-logos">
              <img src="@/assets/trusted/burger-king.png" alt=""/>
              <img width="75px" src="@/assets/trusted/img.png" alt=""/>
              <img src="@/assets/trusted/mc.png" alt=""/>
              <img src="@/assets/trusted/race-trac.png" alt=""/>
              <img src="@/assets/trusted/ace-hardware.png" alt=""/>
              <img src="@/assets/trusted/first-service.png" alt=""/>
              <img src="@/assets/trusted/hooters.png" alt=""/>
              <img src="@/assets/trusted/burger-king.png" alt=""/>
              <img src="@/assets/trusted/wing-stop.png" alt=""/>
              <img src="@/assets/trusted/mc.png" alt=""/>
              <img src="@/assets/trusted/race-trac.png" alt=""/>
              <img src="@/assets/trusted/ace-hardware.png" alt=""/>
              <img src="@/assets/trusted/first-service.png" alt=""/>
              <img src="@/assets/trusted/hooters.png" alt=""/>
            </div>
          </div>
        </div>
      </div>

          <PaymentsDetails :accountType="accountType" :selectedCourses="selectedCourses"
                           :selectedSpecialCourses="selectedSpecialCourses" :locations="locations"
                           :users="users" :totals="totals" :billingCycle="billingCycle" :selected-plan="selectedPlan"
                           :plan="plans" :key="uselessCounter" :isProcessing="loading"
                           @change-billing-cycle="billingCycleUpdate" @promo-applied="handlePromoApplied"
                           @remove-special-course="removeSpecialCourse" @remove-course="removeCourse"
                           @trigger-submit="submitForm"/>


        <div class="trusted m-2 d-sm-none d-none d-lg-block">
          <div class="security-logos-container">
            <div class="text-center mb-2">
              <img class="p-2" src="@/assets/security/259.png" alt=""/>
              <img class="p-2" src="@/assets/security/261.png" alt=""/>
              <img class="p-2" src="@/assets/security/263.png" alt=""/>
              <img class="p-2" src="@/assets/security/264.png" alt=""/>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import VideoHoverPlayer from "@/components/Signup/VideoHoverPlayer.vue";
import Header from "../Common/Header.vue";
import Footer from "../Common/Footer.vue";
import AddLocations from "../../components/Signup/AddLocations.vue";
import PaymentsDetails from "../../components/Signup/PaymentsDetails.vue";
import PlanSelector from "../../components/Signup/PlanSelector.vue";
import ChoosePlatform from "../../components/Signup/ChoosePlatform.vue";
import SelectCourses from "../../components/Signup/SelectCourses.vue";
import UserBillingInfo from "../../components/Signup/UserBillingInfo.vue";
import IncludedCourses from "../../components/Signup/IncludedCourses.vue";
import AddOns from "../../components/Signup/AddOns.vue";
import CompanyBillingInfo from "../../components/Signup/CompanyBillingInfo.vue";
import EnterprisePlanModal from "../../components/Signup/EnterprisePlanModal";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";

export default {
  name: "New-Signup",
  components: {
    Header,
    Footer,
    PaymentsDetails,
    AddLocations,
    PlanSelector,
    ChoosePlatform,
    SelectCourses,
    UserBillingInfo,
    IncludedCourses,
    AddOns,
    CompanyBillingInfo,
    VideoHoverPlayer,
    EnterprisePlanModal
  },
  data() {
    return {
      leadSessionId: null,
      saveLeadTimeout: null,
      accountType: null,
      uselessCounter: 0,
      selectedPlan: {},
      choosePlatform: null,
      showBillingInfo: false,
      isEnterpriseVisible: false,
      billingCycle: "monthly", // For individual accounts, this is just the course price (not a billing cycle)
      promoCode: "",
      locations: 0,
      users: 0,
      locationsAdded: false,
      /** Cache of company billing fields so lead save has them even when ref isn't ready */
      cachedCompanyBillingInfo: {},
      company_types: [],
      courses: [],
      specialCourses: [],
      addons: [],
      selectedAddons: [],
      selectedCoursesIds: [],
      selectedSpecialCoursesIds: [],
      selectedCourses: [],
      selectedSpecialCourses: [],
      totals: {},
      loadingCourses: false,
      loading: false,
      plans: {
        hot: {
          name: "Hot Plan",
          courses: [325, 23],
        },
        sizzling: {
          name: "Sizzling Plan",
          courses: [
            122, 532, 23, 103, 104, 21, 32, 40, 118, 283, 119, 47, 48, 56, 57,
            101, 59, 280, 260, 77, 295, 82, 83, 84, 86, 120, 87, 121, 90, 68, 64,
          ],
        },
        scorching: {
          name: "Scorching Plan",
          courses: [],
        },
      },
    }
  },
  computed: {
    stepText() {
      // Default
      let step = "Step 1";
      if (this.isAccountType("individual")) {
        step = "Step 1/3";
      } else if (
        this.isAccountType("company") &&
        this.isChoosePlatform("chooseLMS")
      ) {
        step = "Step 1/5";
      } else if (this.isChoosePlatform("chooseOtherPlatform")) {
        step = "Step 1/5";
      }
      return step;
    },
  },
  mounted() {
    this.fetchCourses();
    this.leadSessionId = localStorage.getItem('lead_session_id') || this.generateLeadSessionId();
    localStorage.setItem('lead_session_id', this.leadSessionId);
  },
  watch: {
    selectedCoursesIds: { handler() { this.scheduleSaveLead(); }, deep: true },
    selectedSpecialCourses: { handler() { this.scheduleSaveLead(); }, deep: true },
    selectedAddons: { handler() { this.scheduleSaveLead(); }, deep: true },
    selectedPlan: { handler() { this.scheduleSaveLead(); }, deep: true },
    locations() { this.scheduleSaveLead(); },
    users() { this.scheduleSaveLead(); },
    totals: { handler() { this.scheduleSaveLead(); }, deep: true },
    accountType(newType) {
      this.selectedPlan = null;
      this.choosePlatform = null;
      this.selectedCourses = [];
      this.selectedSpecialCourses = [];
      this.showBillingInfo = false;
      this.locations = 0;
      this.users = 0;
      this.locationsAdded = false;
      this.totals = {};
      this.cachedCompanyBillingInfo = {};
      this.scheduleSaveLead();
    },
    choosePlatform(newPlatform) {
      this.selectedCourses = [];
      this.selectedSpecialCourses = [];
      this.showBillingInfo = false;
      this.locations = 0;
      this.users = 0;
      this.locationsAdded = false;
      this.selectedPlan = null;
      this.totals = {};
    },
  },
  methods: {
    generateLeadSessionId() {
      if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID();
      }
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/x/g, () =>
        (Math.random() * 16 | 0).toString(16)
      );
    },
    scheduleSaveLead() {
      if (this.saveLeadTimeout) clearTimeout(this.saveLeadTimeout);
      this.saveLeadTimeout = setTimeout(() => this.saveLead(), 1200);
    },
    /** Called when company billing form fields change; ensures contact details are cached for lead save. */
    onCompanyBillingUpdate(billingSnapshot) {
      if (this.accountType === 'company' && billingSnapshot && typeof billingSnapshot === 'object') {
        this.cachedCompanyBillingInfo = { ...billingSnapshot };
      }
      this.scheduleSaveLead();
    },
    async saveLead() {
      if (!this.leadSessionId && !this.hasAnyLeadContactInfo()) return;
      await this.$nextTick();
      const payload = this.buildLeadPayload();
      if (!payload.session_id && !payload.email) return;
      // Always send session_id so the same lead is updated as user types/selects
      if (this.leadSessionId) payload.session_id = this.leadSessionId;
      try {
        await this.$http.post('new-checkout/save-lead', payload);
      } catch (err) {
        if (err.response?.status !== 422) {
          console.warn('Lead save failed:', err?.response?.data || err.message);
        }
      }
    },
    /** For lead save: individual is one-time payment only (no yearly); company keeps monthly + yearly + per_location/per_user + plan. */
    buildLeadTotals() {
      const t = this.totals || {};
      if (!Object.keys(t).length && this.accountType !== 'company') return undefined;
      if (this.accountType === 'individual') {
        return { total_monthly_cost: t.total_monthly_cost };
      }
      const out = { ...t };
      if (t.per_location != null) out.per_location = t.per_location;
      if (t.per_user != null) out.per_user = t.per_user;
      if (this.selectedPlan && this.selectedPlan.plan) out.plan = String(this.selectedPlan.plan);
      return out;
    },
    hasAnyLeadContactInfo() {
      // Company flow: use ref or cache so we don't skip save when form isn't mounted yet
      if (this.accountType === 'company') {
        const b = (this.$refs.companyForm && this.$refs.companyForm.companyBillingInfo) || this.cachedCompanyBillingInfo || {};
        return !!(b.email || b.firstName || b.companyName);
      }
      const form = this.$refs.userForm || this.$refs.companyForm;
      if (!form) return false;
      const u = form.form ? (form.form.userInfo || {}) : {};
      const b = form.companyBillingInfo || (form.form && (form.form.companyBillingInfo || form.form.billingInfo)) || {};
      return !!(u.email || u.firstName || b.email || b.firstName);
    },
    buildLeadPayload() {
      const planValue = this.accountType === 'company' && this.selectedPlan && this.selectedPlan.plan
        ? String(this.selectedPlan.plan)
        : null;
      const payload = {
        session_id: this.leadSessionId,
        account_type: this.accountType || undefined,
        number_of_locations: this.locations || undefined,
        number_of_employees: this.users || undefined,
        course_ids: this.selectedCoursesIds?.length ? this.selectedCoursesIds : undefined,
        special_courses: this.selectedSpecialCourses?.length
          ? this.selectedSpecialCourses.map(c => ({ id: c.id, users: c.users || 1 }))
          : undefined,
        addons: this.accountType === 'company' ? (Array.isArray(this.selectedAddons) ? this.selectedAddons : []) : (this.selectedAddons?.length ? this.selectedAddons : undefined),
        plan: this.accountType === 'company' ? planValue : undefined,
        selected_course_type: this.accountType === 'company' ? planValue : undefined,
        totals: this.buildLeadTotals(),
        ref_code: localStorage.getItem('ref_code') || undefined,
        ref_code_route: localStorage.getItem('ref_code_route') || undefined,
      };
      // Company flow: read from CompanyBillingInfo (use ref and keep cache so saveLead always has latest)
      if (this.accountType === 'company') {
        const b = (this.$refs.companyForm && this.$refs.companyForm.companyBillingInfo)
          ? this.$refs.companyForm.companyBillingInfo
          : this.cachedCompanyBillingInfo;
        if (b && typeof b === 'object') {
          if (this.$refs.companyForm && this.$refs.companyForm.companyBillingInfo) {
            this.cachedCompanyBillingInfo = { ...this.$refs.companyForm.companyBillingInfo };
          }
          if (b.email) payload.email = b.email;
          if (b.firstName) payload.first_name = b.firstName;
          if (b.lastName) payload.last_name = b.lastName;
          if (b.companyName) payload.company_name = b.companyName;
          if (b.phone) payload.phone_num = b.phone;
          if (b.address_1) payload.address = b.address_1;
          if (b.city) payload.address = (payload.address || '') + (payload.address ? ', ' : '') + (b.city || '');
          if (b.state) payload.state_id = b.state;
          if (b.zip) payload.address = (payload.address || '') + (payload.address ? ' ' : '') + (b.zip || '');
        }
      }
      if (this.accountType !== 'company') {
        const form = this.$refs.userForm || this.$refs.companyForm;
        if (form) {
          const u = form.form ? (form.form.userInfo || {}) : {};
          const b = form.companyBillingInfo || (form.form && (form.form.companyBillingInfo || form.form.billingInfo)) || {};
          if (u.email) payload.email = u.email;
          if (u.firstName) payload.first_name = u.firstName;
          if (u.lastName) payload.last_name = u.lastName;
          if (u.phone) payload.phone_num = u.phone;
          if (b.email) payload.email = payload.email || b.email;
          if (b.firstName) payload.first_name = payload.first_name || b.firstName;
          if (b.lastName) payload.last_name = payload.last_name || b.lastName;
          if (b.companyName) payload.company_name = b.companyName;
          if (b.phone) payload.phone_num = payload.phone_num || b.phone;
          if (b.address_1) payload.address = b.address_1;
          if (b.city) payload.address = (payload.address || '') + (payload.address ? ', ' : '') + (b.city || '');
          if (b.state) payload.state_id = b.state;
          if (b.zip) payload.address = (payload.address || '') + (payload.address ? ' ' : '') + (b.zip || '');
        }
      }
      return payload;
    },
     billingCycleUpdate(cycle) {
      this.billingCycle = cycle;
      this.uselessCounter++;
    },
    openEnterpriseModal() {
      this.isEnterpriseVisible = true;
    },
    async handlePromoApplied(data, code) {
      this.promoCode = code;
      this.totals = data;
      await this.calculatePriceApi()
    }, async handleAddOnsSelected(selectedAddOns) {
      this.selectedAddons = selectedAddOns;
      await this.calculatePriceApi()
    }, async handleAddonsCourses(selectedCourses) {
      this.selectedSpecialCourses = selectedCourses;
      await this.calculatePriceApi()
    },
    async removeCourse(courseId) {
      this.selectedCourses = this.selectedCourses.filter(c => c.id !== courseId);
      this.selectedCoursesIds = this.selectedCourses.map(course => course.id);
      await this.calculatePriceApi()
    },
    async removeSpecialCourse(courseId) {
      this.selectedSpecialCourses = this.selectedSpecialCourses.filter(c => c.id !== courseId);
      this.selectedSpecialCoursesIds = this.selectedSpecialCourses.map(course => course.id);
      await this.calculatePriceApi()
    },
    isAccountType(type) {
      return this.accountType === type;
    },
    isChoosePlatform(type) {
      return this.choosePlatform === type;
    },
    submitForm() {
      if (this.$refs.companyForm) {
        this.$refs.companyForm.submitForm();
      } else if (this.$refs.userForm) {
        this.$refs.userForm.submitForm();
      }
    },
    onPlanChange(payload) {
      if (payload) {
        this.selectedPlan = payload;
        this.selectedCoursesIds = payload.courses;
        this.locations = payload.controls.locations;
        this.users = payload.controls.users;
        this.selectedCoursesIds = payload.courses;
        this.selectedSpecialCoursesIds = payload.specialCourses;
      } else {
        this.selectedPlan = null;
      }
    },
    onCoursesSelected({selectedCourses, selectedSpecialCourses}) {
      this.selectedCourses = selectedCourses;
      this.selectedCoursesIds = this.selectedCourses.map(course => course.id);
      this.selectedSpecialCourses = selectedSpecialCourses;
      this.calculatePriceApi()
      this.showBillingInfo = (selectedCourses && selectedCourses.length > 0) || (selectedSpecialCourses && selectedSpecialCourses.length > 0);
    },
    onBillingFormSubmitted(formData) {

      const {form} = formData;

      let payload = {
        selected_plan: this.selectedPlan,
        billing_cycle: this.billingCycle,
        promo_code: this.promoCode || null,
        totals: this.totals,
        course_ids: this.selectedCoursesIds,
        special_courses: this.selectedSpecialCourses,
        locations: this.locations,
        users: this.users,
        addons: this.selectedAddons,
      };

      if (this.accountType === "company") {
        const billing = form.companyBillingInfo || {};
        payload.payment_type = form.paymentType;
        payload.first_name = billing.firstName || "";
        payload.last_name = billing.lastName || "";
        payload.company_name = billing.companyName || "";
        payload.company_email = billing.email || "";
        payload.company_phone = billing.phone || "";
        payload.company_address_1 = billing.address_1 || "";
        payload.company_city = billing.city || "";
        payload.company_state = billing.state || "";
        payload.company_zip = billing.zip || "";


        const transactionAmount =
          form.billingCycle === "monthly"
            ? this.totals.total_monthly_cost?.toFixed(2)
            : this.totals.total_annually_cost?.toFixed(2);

        // Handle payment methods
        if (form.paymentType === "creditCard") {
          const card = form.cardInfo?.stripe_token?.card || {};
          payload.payment = {
            payment_type: this.billingCycle,
            cardholder_street_address: [
              card.address_line1,
              card.address_city,
              card.address_state,
            ]
              .filter(Boolean)
              .join(", "),
            cardholder_zip: card.address_zip || "",
            transaction_amount: transactionAmount,
            token: form.cardInfo?.stripe_token,
          };
        } else if (form.paymentType === "ach") {
          const ach = form.ACH || {};
          payload.payment = {
            payment_type: "ach",
            ach: true,
            account_type: ach.accountType || "checking",
            account_number: ach.account_number || "",
            transit_number: ach.transit_number || "",
            financial_instituation: ach.financial_instituation || "",
            branch: ach.branch || "",
            transaction_amount: transactionAmount,
          };
        } else if (form.paymentType === "invoice") {
          const invoice = form.Invoice || {};
          payload.payment = {
            payment_type: "invoice",
            invoice: true,
            invoice_name: invoice.invoice_name || "",
            invoice_emails: invoice.invoice_emails || "",
            invoice_phone: invoice.invoice_phone || "",
            invoice_address: invoice.invoice_address || "",
            invoice_city: invoice.invoice_city || "",
            invoice_state: invoice.invoice_state || "",
            transaction_amount: transactionAmount,
          };
        }
      }


      if (this.accountType === "individual") {
        payload.user_type = this.accountType;
        payload.employee_first_name = form.userInfo.firstName;
        payload.employee_last_name = form.userInfo.lastName;
        payload.employee_email = form.userInfo.email;
        payload.employee_phone = form.userInfo.phone;
        payload.employee_address = form.billingInfo.address;
        payload.employee_city = form.billingInfo.city;
        payload.employee_state = form.billingInfo.state;
        payload.employee_zipCode = form.billingInfo.zipCode;
        // For individual accounts, it's just the course price (not a monthly/annual subscription)
        payload.payment = {
          payment_type: "monthly", // Legacy value - for individuals this is just the one-time course price
          cardholder_zip: form.cardInfo.stripe_token?.card?.address_zip || "",
          transaction_amount: this.totals.total_monthly_cost?.toFixed(2), // This is the course price
          token: form.cardInfo.stripe_token,
        };
      }
      payload.promo_code = this.promoCode;
      if (this.promoCode) {
        payload.course_cost_monthly = this.totals.total_monthly_cost?.toFixed(2);
        payload.course_cost_yearly = this.totals.total_annually_cost?.toFixed(2);
      }
      // For individual accounts, use course price; for company, use billing cycle
      payload.discounted_cost = this.accountType === "individual"
        ? this.totals.total_monthly_cost?.toFixed(2) // Course price for individuals
        : (form.billingCycle === "monthly"
          ? this.totals.total_monthly_cost?.toFixed(2)
          : this.totals.total_annually_cost?.toFixed(2));
      payload.ref_code = localStorage.getItem("ref_code");
      payload.ref_code_route = localStorage.getItem("ref_code_route");
      const endpoint =
        this.accountType === "individual"
          ? "employees/register"
          : "company/register";

      // return
      this.registerAccount(payload, endpoint);
    },
    async onLocationsAdded({locations, users}) {
      this.locations = locations;
      this.users = users;
      this.locationsAdded = true;
      await this.calculatePriceApi()
    },
    async fetchCourses() {
      this.loadingCourses = true;
      try {
        const resp = await this.$http.get("new-checkout/get-courses");

        this.courses = resp.data.courses
        this.addons = resp.data.services;

      } catch (error) {
        console.error("Failed to load Courses:", error);
      } finally {
        this.loadingCourses = false;
      }
    },
    async calculatePriceApi() {
      try {
        const payload = {
          promo_code: this.promoCode,
          account_type: this.accountType,
          plan: this.selectedPlan?.plan || null,
          course_ids: this.selectedCoursesIds,
          addons: this.selectedAddons,
          special_courses: this.selectedSpecialCourses.map(c => ({
            id: c.id,
            users: c.users,
          })),
          total_users: this.users,
          locations: this.locations
        };

        const response = await this.$http.post('new-checkout/calculate-total', payload);
        this.totals = response.data
      } catch (error) {
        console.error("planLead error:", error);
      }
    },
    registerAccount(payload, endpoint) {
      this.loading = true;
      delete this.$http.defaults.headers["authorization"];

      this.$http
        .post(endpoint, payload)
        .then((resp) => {
          Swal.fire({
            title: "Success!",
            html: `Your account has been created and is now active! <a href="https://lms.homeoftraining.com/#/login">Click here</a> to Login`,
            icon: "success",
            confirmButton: "btn btn-success",
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.value) {
              this.$router.push("/login");
            }
          });
        })
        .catch((error) => {

          Swal.fire({
            title: "Error!",
            text: error.response?.data?.message || "Something went wrong!",
            icon: "error",
          });
        })
        .finally(() => {
          this.loading = false;
          if (this.accountType === 'individual') {
            if (this.$refs.userForm) {
              this.$refs.userForm.isProcessing = false;
            }
          } else {
            if (this.$refs.companyForm) {
              this.$refs.companyForm.isProcessing = false;
            }
          }
        });
    },
  },

}
</script>
<style lang="scss" scoped>
h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0;
}

a {
  text-decoration: none;
}

.main-wrapper {
  margin-block: 30px;
}

// intro section style
.intro-section {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 49px;
  justify-content: space-between;

  .start-journey {
    width: 100%;

    h2 {
      font-size: 26px;
      font-weight: 700;
      line-height: 33px;
      color: rgba(37, 37, 37, 1);
      margin-bottom: 20px;
    }

    .info {
      p:first-child {
        margin-bottom: 12px;
      }

      p {
        font-size: 12px;
        line-height: 15px;
        color: rgba(37, 37, 37, 1);

        a {
          font-weight: 700;
        }
      }
    }
  }

  .trusted {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;

    h4 {
      font-size: 14px;
      line-height: 18px;
      font-weight: 700;
    }

    .sponsor-logos-container {
      position: relative;
      width: 296px;
      overflow: hidden;
    }

    .sponsor-logos {
      display: flex;
      animation: scroll 30s linear infinite;
      gap: 17px;

      img {
        object-fit: contain;
      }
    }

    @keyframes scroll {
      0% {
        transform: translateX(0);
      }

      100% {
        transform: translateX(-100%);
      }
    }
  }
}

/* main section styles */
.main-section {
  display: flex;
  gap: 35px;
  margin-top: 36px;
  flex-direction: column;
  align-items: flex-start;
}

.left-col {
  position: relative;
  width: 100%;
}

.step-badge {
  position: absolute;
  right: 0;
  top: -7px;
  background: #fff0ea;
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 10px;
  line-height: 23px;
  font-weight: 700;
  color: #252525;
}

.title {
  font-size: 20px;
  line-height: 25px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #252525;
}

.subtitle {
  font-size: 20px;
  line-height: 25px;
  color: #252525;
  margin-bottom: 22px;
  display: none;
}

.account-type {
  display: flex;
  gap: 12px;
  align-items: stretch;

  .account-type-card {
    display: flex;
    align-items: center;
    flex-direction: column !important;
    flex: 1 1 0;
    min-width: 0;
    justify-content: center !important;
    gap: 18px;
    padding: 17px;
    border-radius: 12px;
    border: 2px solid rgba(255, 106, 74, 0.12);
    background: #fff;
    transition: border-color 180ms ease, box-shadow 180ms ease,
    transform 120ms ease;
    position: relative;

    .card-body {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 16px;
      color: #252525;

      h3 {
        font-size: 14px;
        line-height: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        flex-wrap: nowrap;
      }

      p {
        font-size: 12px;
        line-height: 15px;
        font-weight: 500;
      }
    }

    .select-dot {
      position: absolute;
      right: 18px;
      top: 18px;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 2px solid rgba(200, 200, 200, 0.6);
    }

    img {
      width: 40px;
      height: 40px;
    }
  }
}

.account-type input[type="radio"] {
  display: none;
}

.account-type input[type="radio"]:checked + .account-type-card {
  border: 2px solid #eb1a26;
  box-shadow: 0 10px 30px rgba(255, 106, 74, 0.12);
  transform: translateY(-2px);
}

.account-type input[type="radio"]:checked + .account-type-card .select-dot {
  background: radial-gradient(circle at 30% 30%, #fff, #ffd6cc);
  border: 4px solid #ff6a4a;
}

@media (min-width: 1024px) {
  .main-wrapper {
    margin-block: 44px;
  }

  .intro-section {
    padding-inline: 0;
    flex-direction: row;

    .start-journey {
      width: 65%;

      h2 {
        font-size: 45px;
        font-weight: 700;
        line-height: 57px;
        margin-bottom: 30px;
      }

      .info {
        p:first-child {
          margin-bottom: 18px;
        }

        p {
          font-size: 16px;
          line-height: 20px;
        }
      }
    }

    .trusted {
      h4 {
        font-size: 20px;
        line-height: 25px;
      }

      .sponsor-logos-container {
        width: 346px;
      }
    }
  }

  .main-section {
    flex-direction: row;
  }

  .left-col {
    width: 65%;
  }

  .step-badge {
    position: absolute;
    right: 0;
    top: 0;
    background: #fff0ea;
    padding: 10px 14px;
    border-radius: 16px;
    font-size: 18px;
    line-height: 23px;
    font-weight: 700;
    color: #252525;
  }

  .title {
    font-size: 32px;
    line-height: 40px;
    font-weight: 700;
    margin-bottom: 8px;
    color: #252525;
  }

  .subtitle {
    font-size: 20px;
    line-height: 25px;
    color: #252525;
    margin-bottom: 22px;
    display: block;
  }

  .right-col {
    width: 35%;
    position: sticky;
    top: 20px;
    height: fit-content;
    align-self: flex-start;
  }

  .account-type {
    flex-direction: row;

    .account-type-card {
      flex-direction: row;
      align-items: center;
      padding: 26px;

      .card-body {
        gap: 16px;
        color: #252525;

        h3 {
          font-size: 18px;
          line-height: 23px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          flex-wrap: nowrap;
        }

        p {
          font-size: 14px;
          line-height: 18px;
          font-weight: 500;
        }
      }

      .select-dot {
        position: absolute;
        right: 18px;
        top: 18px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 2px solid rgba(200, 200, 200, 0.6);
      }
    }
  }
}
@media (max-width: 768px) {
  ::v-deep(.video-hover-player) {
    display: none !important;
  }
  ::v-deep(.video-hover-player *) {
    display: none !important;
  }
}
</style>
